import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  inject,
  OnInit,
  TemplateRef,
  ViewChild
} from '@angular/core';
import {MatIcon} from '@angular/material/icon';
import {MatButton, MatIconButton} from '@angular/material/button';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {MatFormField, MatFormFieldModule} from '@angular/material/form-field';
import {FormBuilder, FormsModule, ReactiveFormsModule} from '@angular/forms';
import {
  ApiGradeGetRequestParams,
  DepartmentService,
  OrganizationService,
  ReferenceService,
  UserService
} from '../../../apiModule1';
import {NgClass, NgStyle, NgTemplateOutlet} from '@angular/common';
import {MatLabel} from '@angular/material/select';
import {MatInput, MatInputModule} from '@angular/material/input';
import {map} from 'rxjs/operators';
import {MultiSelect2Component} from '../../../../shared/components/multi-select2/multi-select2.component';
import {OnInputChange} from '../../OnInputChange';
import {quarters, years} from '../../index-ias/filter-dialog/filter-dialog.component';
import {
  MatExpansionModule,
  MatExpansionPanel,
  MatExpansionPanelHeader,
  MatExpansionPanelTitle
} from '@angular/material/expansion';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {DateAdapter, MAT_DATE_LOCALE} from '@angular/material/core';
import {CustomDateAdapter} from '../../../../custom-date-adapter';
import 'moment/locale/ru';

@Component({
  selector: 'pas-filter-grade',
  standalone: true,
  imports: [
    MatIcon,
    MatIconButton,
    MatFormField,
    ReactiveFormsModule,
    MatLabel,
    MatInput,
    MatButton,
    NgClass,
    NgStyle,
    MultiSelect2Component,
    MatExpansionPanel,
    MatExpansionPanelTitle,
    MatExpansionPanelHeader,
    NgTemplateOutlet,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatExpansionModule,
    MatDatepickerModule,
    MatInputModule
  ],
  templateUrl: './filter-dialog.component.html',
  styleUrls: ['./filter-dialog.component.scss', '../../index-entity/filter-dialog/filter-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {provide: DateAdapter, useClass: CustomDateAdapter}, // Используйте ваш пользовательский адаптер
    {provide: MAT_DATE_LOCALE, useValue: 'ru-RU'},
  ]
})
export class FilterDialogComponent implements OnInit {
  @ViewChild('department') departmentTemplate!: TemplateRef<any>
  @ViewChild('organization') organizationTemplate!: TemplateRef<any>

  cdr = inject(ChangeDetectorRef);
  dialogRef = inject(MatDialogRef<FilterDialogComponent>);
  referenceService = inject(ReferenceService);
  organizationService = inject(OrganizationService);
  departmentService = inject(DepartmentService);
  userService = inject(UserService);
  data: Record<string, any> = inject(MAT_DIALOG_DATA)
  fb = inject(FormBuilder)

  archiveStatuses: Status[] = []
  organizations: Organization[] = []
  departments: Department[] = []
  periods: CriterionPeriod[] = []
  years: { id: number, name: string }[] = years
  quarters: { id: number, name: string }[] = quarters
  users: UserFioName[] = []
  statuses: Status[] = []

  form = this.fb.group({
    archive: [this.data && this.data['statusIds'] || []],
    organization: [this.data && this.data['organizationIds'] || []],
    period: [this.data && this.data['periodIds'] || []],
    year: [this.data && this.data['years'] && this.data['years'].map((v: number) => years.find(y=> y.name == v.toString()))|| []],
    quarter: [this.data && this.data['quarters'] || []],
    user: [this.data && this.data['userIds'] || []],
    status: [this.data && this.data['gradeStatusIds'] || []],
    executorType: [this.data && this.data['executorType']],
    organizationExecutor: [this.data && this.data['organizationExecutorIds'] || []],
    departmentExecutor: [this.data && this.data['departmentExecutorIds'] || []],
    dateFrom: [this.data && this.data['dateFrom'] || ''],
    dateTo: [this.data && this.data['dateTo'] || ''],
  })

  // constructor(private _adapter: DateAdapter<Date>) {
  //   this._adapter.setLocale('ru-RU')
  // }

  get isExecutorDepartment(): boolean {
    return this.form.get('executorType')!.value === 'Department'
  }

  get isExecutorOrganization(): boolean {
    return this.form.get('executorType')!.value === 'Organization'
  }

  get whichTemplateToUse(): TemplateRef<any> | null {
    if (this.isExecutorDepartment) return this.departmentTemplate
    if (this.isExecutorOrganization) return this.organizationTemplate
    return null
  }

  dataOrganization: OnInputChange<Organization> = new OnInputChange(this.organizationService, 'apiOrganizationFilterlistGet', 'grade')
  dataDepartment: OnInputChange<Department> = new OnInputChange(this.departmentService, 'apiDepartmentFilterlistGet', 'grade')
  dataUser: OnInputChange<User> = new OnInputChange(this.userService, 'apiUserFilterlistGet', 'grade')

  onNoClick(): void {
    this.dialogRef.close();
  }

  ngOnInit(): void {
    console.log('filter-dialog data', this.data);

    this.referenceService.apiReferenceStatusesGet().pipe(map(v => v.values)).subscribe((v: Status[]) => {
      this.archiveStatuses = v;
    })
    this.referenceService.apiReferencePeriodsGet().pipe(map(v => v.values)).subscribe((v: CriterionPeriod[]) => {
      this.periods = v;
    })
    this.referenceService.apiReferenceGradestatusesGet().pipe(map(v => v.values)).subscribe((v: Status[]) => {
      this.statuses = v;
    })
    this.userService.apiUserFilterlistGet({filteredObjectName: 'grade'})
      .pipe(map(v => v.values))
      .subscribe((v: User[]) => {
        this.users = v.map(convertUserToUserFioName);
      })

    //
    this.dataOrganization.on().subscribe(v => {
      this.organizations = v;
      this.cdr.markForCheck();
    })
    this.dataDepartment.on().subscribe(v => {
      this.departments = v;
      this.cdr.markForCheck();
    })
    this.dataUser.on().subscribe(v => {
      this.users = v.map(convertUserToUserFioName);
      this.cdr.markForCheck();
    })

  }


  onReset(): void {
    this.form.reset();
  }

  onApply() {
    const res: ApiGradeGetRequestParams = {
      statusIds: this.form.get('archive')!.value || [],
      organizationIds: this.form.get('organization')!.value || [],
      periodIds: this.form.get('period')!.value || [],
      years: this.form.get('year')!.value.map((v: { id: number, name: string })=>v.name) || [],
      quarters: this.form.get('quarter')!.value || [],
      userIds: this.form.get('user')!.value || [],
      gradeStatusIds: this.form.get('status')!.value || [],
      executorType: this.form.get('executorType')!.value || null,
      organizationExecutorIds: this.form.get('organizationExecutor')!.value || [],
      departmentExecutorIds: this.form.get('departmentExecutor')!.value || [],
      dateFrom: this.form.get('dateFrom')!.value && this.form.get('dateFrom')!.value.toISOString() || null,
      dateTo: this.form.get('dateTo')!.value && this.form.get('dateTo')!.value.toISOString() || null,
    }

    this.dialogRef.close(res);
  }

}


export const convertUserToUserFioName = (user: User): UserFioName => {
  const {lastName, firstName, middleName} = user;
  const res: UserFioName = {...user, name: `${lastName} ${firstName} ${middleName}`};
  return res;
}
